<template>
  <div>
    <div class="pre-footer">
      <div class="container">
        <div class="row">
          <AboutBTC id="aboutbtc"/>
          <terms id="terms"/>
          <privacy-policy id="privacypolicy"/>
          <contact-us id="contactus"/>
          <div class="col-md-3 col-xs-3 pre-footer-col" style="text-align:center">
            <a href="#" data-toggle="modal" data-target="#aboutbtc">
              <h2>About BTC</h2>
            </a>
          </div>
          <div class="col-md-3 col-xs-3 pre-footer-col" style="text-align:center">
            <a href="#" data-toggle="modal" data-target="#terms">
              <h2>Terms & Conditions</h2>
            </a>
          </div>
          <div class="col-md-3 col-xs-3 pre-footer-col" style="text-align:center">
            <a href="#" data-toggle="modal" data-target="#privacypolicy">
              <h2>Privacy Policy</h2>
            </a>
          </div>
          <div class="col-md-3 col-xs-3 pre-footer-col" style="text-align:center">
            <a href="#" data-toggle="modal" data-target="#contactus">
              <h2>Contact Us</h2>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="container">
        <div class="row">
          <div style="text-align: center" class="col-md-12 col-sm-12 padding-top-10">
            Copyright © 2014-2021 Beef to China. All Rights Reserved.<br>
            <a href="http://beian.miit.gov.cn" target="_blank">{{ getIcp() }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AboutBTC from './components/AboutBTC'
import Terms from './components/Terms'
import PrivacyPolicy from './components/PrivacyPolicy'
import ContactUs from './components/ContactUs'

export default {
  components: {
    AboutBTC,
    Terms,
    PrivacyPolicy,
    ContactUs
  },
  methods: {
    getIcp() {
      let icp = '蜀ICP备19014942号-1'
      if (/www.beeftochina.cn/g.test(window.location.href)) {
        icp = '蜀ICP备19014942号-2'
      }
      return icp
    }
  }
}
</script>

<style scoped>
a { text-decoration: none; }
h2 { font-size: 15px; font-weight: 200; color: #b0b0b0 }
</style>



// WEBPACK FOOTER //
// src/views/layout_en/components/Footer/index.vue